import request from '@/utils/request'
// import qs from 'qs'

// 分页查看所有报告
export const reportList = (getData) => {
  return request({
    url: '/back/template/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 根据id查看详情
export const getList = (getData) => {
  return request({
    url: '/back/template/getById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除报告
export const deleteReport = (getData) => {
  return request({
    url: '/back/template/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改报告
export const updateReport = (postData) => {
  return request({
    url: '/back/template/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增报告
export const addReport = (postData) => {
  return request({
    url: '/back/template/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 根据报告id查看报告中未绑定报告的仪器的列表
export const queryToolList = (getData) => {
  return request({
    url: '/back/template/queryToolList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 根据报告id查看报告中未绑定报告的事项的列表
export const queryItemList = (getData) => {
  return request({
    url: '/back/template/queryItemList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
